module.exports = __webpack_public_path__ + "fonts/InstagramSans-Regular.d66a331b.woff2";